<template>
  <div class="page" v-loading="loading">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>订单</el-breadcrumb-item>
        <el-breadcrumb-item>售后预约</el-breadcrumb-item>
        <el-breadcrumb-item>货品售后</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="21">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-select size="mini" v-model="filter.store_id" value-key="" filterable placeholder="选择店铺">
              <el-option label="所有店铺" value=""></el-option>
              <el-option v-for="store in stores" :key="store.id" :label="store.title" :value="store.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select size="mini" v-model="filter.time_type" style="width: 120px">
              <el-option label="下单时间" value="created_at"></el-option>
              <el-option label="尾款支付时间" value="payed_at"></el-option>
              <el-option label="定金支付时间" value="front_payment_time"></el-option>
              <el-option label="收货时间" value="kd_adminer_time"></el-option>
              <el-option label="预处理时间" value="pretreatment_time"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-date-picker
              size="mini"
              v-model="filter.date_range"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="filter.keyword"
              placeholder="搜索订单号 / 昵称 / 手机号"
              size="mini"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-select size="mini" v-model="filter.sort_type" clearable placeholder="排序选择" style="width: 120px">
              <el-option label="订单创建时间" value="1"></el-option>
              <el-option label="星级" value="2"></el-option>
              <el-option label="预处理时间" value="3"></el-option>
              <el-option label="预约提交时间" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSearch" size="mini">查询</el-button>
            <el-button type="warning" @click="onRefresh" size="mini">刷新</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-checkbox-group v-model="checkList" @change="checkChange">
      <el-checkbox-button :label="-1">全部({{ totalData.all_count }})</el-checkbox-button>
      <el-checkbox-button :label="1">已发货({{ totalData.status1 }})</el-checkbox-button>
      <el-checkbox-button :label="2">已完成({{ totalData.status2 }})</el-checkbox-button>
      <el-checkbox-button :label="3">已取消({{ totalData.status3 }})</el-checkbox-button>
      <el-checkbox-button :label="4">退款中({{ totalData.status4 }})</el-checkbox-button>
      <el-checkbox-button :label="5">已退款({{ totalData.status5 }})</el-checkbox-button>
    </el-checkbox-group>

    <el-radio-group v-model="radioVal" @change="radioChange" style="margin: 5px 0px;">
      <el-radio-button :label="7">今日待处理({{ totalData.pending }})</el-radio-button>
      <el-radio-button :label="8">今日已处理({{ totalData.processed }})</el-radio-button>
    </el-radio-group>

    <div class="order_table" v-for="(order, i) in tableData" :key="i">
      <div class=" order">
        <div class="order-header">
          <div class="order-no">
            <span class="index">#{{ i + 1 }}</span>
            <span>
              平台：<el-tag effect="dark" :color="order.store.platform.color" size="mini">
                {{ order.store.platform.title }}
              </el-tag>
            </span>
            <span>店铺名：{{ order.store.title }}</span>
            <span
              >订单号：{{ order.order_no }}
              <el-link type="primary" @click="showOrder(order.orders.order_no)">
                <i class="el-icon-paperclip"></i>
              </el-link>
            </span>
            <span class="order-create">下单时间：{{ order.created_at }}</span>
          </div>
          <span style="margin-right: 100px;">操作</span>
        </div>
        <div class="order-body">
          <div class="order-items">
            <div class="order-item" v-for="(orderItem, ind) in order.order_items" :key="ind">
              <div class="good">
                <div class="good-box">
                  <div style="width: 100%; display: flex">
                    <div class="good-img">
                      <el-image :src="orderItem.thumb" fit="fill"></el-image>
                    </div>
                    <div class="good-info">
                      <div class="good-title">
                        <div>商品编码：【{{ orderItem.good.good_no ? orderItem.good.good_no : '' }}】</div>
                        <div>商品名称：{{ orderItem.good.title }}</div>
                        <div>落地名称：{{ orderItem.good.small_title }}</div>
                      </div>
                      <div class="order-payment">
                        <div class="payment">
                          <span>销售金额：</span>
                          <span>
                            {{ (parseFloat(orderItem.payment) + parseFloat(orderItem.pay_balance)).toFixed(2) }} x
                            {{ orderItem.num }}
                          </span>
                        </div>
                        <div class="payment">
                          <span>优惠金额：</span>
                          <span>¥0.00</span>
                        </div>
                        <div class="payment">
                          <span>使用余额：</span>
                          <span> ¥{{ order.pay_balance }} </span>
                        </div>
                        <div class="payment">
                          <span style="color: #FE2E40;">实付金额：</span>
                          <span style="color: #FE2E40;"> ¥{{ order.payment }} </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="membermsg">
                    <div class="member">
                      <div>
                        客户昵称：
                        {{ order.member && order.member.nickname ? order.member.nickname : '' }}
                      </div>
                      <div>
                        电话：
                        {{ order.member && order.member.mobile ? order.member.mobile : '' }}
                      </div>
                      <div>
                        付款状态：<span style="color: #007CFF;"> &nbsp;{{ order.status_text }} {{ order.payed_at }} </span>
                      </div>
                      <div>
                        付款方式：
                        <span style="color: #007CFF;"> &nbsp;{{ order.pay_type_text }} </span>
                      </div>
                      <div>
                        付款条件：
                        <span style="color: #007CFF;"> &nbsp;{{ order.settlement_type == 0 ? '现结' : '月结' }} </span>
                      </div>
                    </div>
                    <div
                      v-if="orderItem.good && orderItem.good.products && orderItem.good.products.length > 0"
                      style="flex: 1; padding-bottom: 5px; margin-top: 5px;"
                    >
                      <div v-for="product in orderItem.good.products" :key="product.id">
                        <el-dropdown>
                          <span
                            v-if="product.channel_title && product.channel_title.length > 0"
                            class="el-dropdown-link"
                            style="font-size: 12px !important;"
                          >
                            商品渠道：<span>
                              【{{ product.channel_title[0].code ? product.channel_title[0].code : '' }}】{{
                                product.channel_title[0].title ? product.channel_title[0].title : ''
                              }}
                            </span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <span v-else style="margin-top: 5px;">
                            商品渠道：【】
                          </span>
                          <div v-if="product.channel_title && product.channel_title.length > 0">
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item v-for="channel in product.channel_title" :key="channel.id">
                                【{{ channel.code ? channel.code : '' }}】{{ channel.title ? channel.title : '' }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </div>
                          <div v-else style="margin-top: 5px;">
                            <span class="el-dropdown-link" style="font-size: 12px !important; letter-spacing: 2px">
                              商品渠道：【】</span
                            >
                          </div>
                        </el-dropdown>
                      </div>
                    </div>
                    <div v-else style="margin-top: 5px;">
                      <span class="el-dropdown-link" style="font-size: 12px !important; letter-spacing: 2px">
                        商品渠道：【】</span
                      >
                    </div>
                  </div>
                </div>
                <div class="good-verifies">
                  <div class="verify" v-for="(verify, index) in orderItem.order_pretreatments" :key="index">
                    <div class="verify-body wrap1">
                      <div>
                        <div>
                          <i class="el-icon-user" style="color: #007CFF;"></i>
                          &nbsp;收件人：
                          {{ order.consignee ? order.consignee : '' }}
                        </div>
                        <div>
                          <i class="el-icon-mobile-phone" style="color: #007CFF"></i>
                          &nbsp;手机号：{{ order.mobile }}
                        </div>
                        <div>
                          <i class="el-icon-location-outline" style="color: #007CFF"></i>
                          &nbsp;收件地址：
                          {{ order.address ? order.address : '' }}
                        </div>
                        <div>
                          <i class="el-icon-truck" style="color: #007CFF"></i>
                          &nbsp;快递/物流：
                          {{ order.kd_name ? order.kd_name : '' }}
                        </div>
                        <div>
                          <i class="el-icon-folder-checked" style="color: #007CFF"></i>
                          &nbsp;快递单号：
                          {{ order.kd_no ? order.kd_no : '' }}
                        </div>
                        <div class="flexd">
                          <i class="el-icon-time" style="color: #007CFF; margin-right: 4px;"></i>
                          &nbsp;发货时间：
                          {{ order.kd_adminer_time ? order.kd_adminer_time : '' }}
                        </div>
                      </div>
                    </div>
                    <div class="verify-body wrap2">
                      <div>
                        发货状态：<tableEditSelect
                          propsName="shipping_status"
                          @subQuick="getTableData"
                          :options="statusList"
                          :info="verify"
                          url="order/order_pretreatment/quick"
                        >
                        </tableEditSelect>
                      </div>
                      <div style="margin-top: 20px;">
                        发货人：{{ order.kd_adminer ? order.kd_adminer : '' }}（{{
                          order.kd_adminer_time ? order.kd_adminer_time : ''
                        }}）
                      </div>
                      <div
                        class="flexd"
                        style="margin-top: 20px;"
                        v-if="verify.shipping_status == 0 || verify.shipping_status == 1"
                      >
                        处理星级：
                        <el-rate :value="verify.dispose_star" @change="value => star(value, verify.id, verify)"> </el-rate>
                      </div>
                      <div class="flexd" v-if="verify.shipping_status == 0 || verify.shipping_status == 1">
                        预处理时间：
                        <tableEditDate propsName="pretreatment_time" :info="verify" url="order/order_pretreatment/quick">
                        </tableEditDate>
                      </div>
                      <div @click="showRemarks(verify.id, verify.remark_logs)">
                        <div v-if="verify.remark_logs.length > 0">
                          备注：
                          <el-link type="danger" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 4"></el-link>
                          <el-link type="primary" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 3"></el-link>
                          <el-link type="warning" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 2"></el-link>
                          <el-link type="info" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 1"></el-link>
                        </div>
                        <div v-else>备注：<el-link type="info" icon="el-icon-s-flag"></el-link></div>
                      </div>
                      <div class="btngroup">
                        <el-button size="mini" type="danger" @click="onErr(verify)" v-if="verify.shipping_status == 0"
                          >退回
                        </el-button>
                        <el-button
                          v-if="verify.shipping_status == 0 || verify.shipping_status == 1"
                          size="mini"
                          type="warning"
                          @click="save"
                          >保存</el-button
                        >
                        <el-button size="mini" type="warning" @click="toRefundDetainment(order.id, orderItem.id, verify.id)"
                          >退款挽留
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="orderItem.good && orderItem.is_more && orderItem.is_more == 1"
                    class="moreCode"
                    @click="getMoreCode(order.id, orderItem.id)"
                  >
                    查看更多
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="operation">
            <div style="margin-bottom: 10px;">发货进度：</div>
            <div :key="key" v-for="(item, key) in order.statusLists">
              <div
                class="speeds"
                :style="
                  item == '待发货'
                    ? 'background: #FE2E40;'
                    : item == '已发货'
                    ? 'background: #FCBA07;'
                    : item == '退款中'
                    ? 'background: #007CFF;'
                    : item == '已完成'
                    ? 'background: #0BBD3C;'
                    : item == '已取消'
                    ? 'background: #999999;'
                    : 'background: #B8B8B8;'
                "
              >
                {{ item }}
              </div>
              <i
                style="margin-top: 5px; margin-bottom: 5px; color: #007CFF"
                v-if="key < order.statusLists.length - 1"
                class="el-icon-bottom"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flexd">
      <el-pagination
        background
        layout="prev, pager, next, total,jumper"
        :page-count="maxpage"
        :total="total"
        @current-change="pageChange"
      >
      </el-pagination>
      <el-button size="mini" @click="pageChange" class="btn">确定</el-button>
    </div>

    <el-dialog title="编辑信息" :visible.sync="infoShow" width="40%" @close="resetInfo" :close-on-click-modal="false">
      <el-form :model="info" ref="info" :rules="rules" label-width="120px" :inline="false" size="small">
        <el-form-item label="体检人姓名" prop="realname">
          <el-input v-model="info.realname"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="info.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="婚否" prop="merry">
          <el-radio-group v-model="info.merry">
            <el-radio :label="1">已婚</el-radio>
            <el-radio :label="2">未婚</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证件号" prop="id_no">
          <el-input v-model="info.id_no"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="info.mobile"></el-input>
        </el-form-item>
        <el-form-item label="体检机构" prop="org_id">
          <el-select v-model="info.org_id" placeholder="选择分院" filterable>
            <el-option v-for="shop in shops" :key="shop.id" :label="shop.title" :value="shop.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接种机构" prop="inoculate_org_id">
          <el-select v-model="info.inoculate_org_id" placeholder="无选择" filterable>
            <el-option v-for="shop in shops2" :key="shop.id" :label="shop.title" :value="shop.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="infoShow = false">取消</el-button>
        <el-button type="primary" @click="subInfo">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="备注记录" :visible.sync="showRemarksStatus" width="40%" @close="resetRemark">
      <el-form :model="remarkForm" ref="remarkForm" :rules="remarkRules" label-width="80px" :inline="false" size="normal">
        <el-form-item label="标记">
          <el-radio-group v-model="remarkForm.type">
            <el-radio :label="1">
              <el-link type="info" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="2">
              <el-link type="warning" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="3">
              <el-link type="primary" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="4">
              <el-link type="danger" icon="el-icon-s-flag"></el-link>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="remarkForm.remark" placeholder="请填写备注" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="this.remarks" border stripe>
        <el-table-column type="index" label="序号" width="70px"></el-table-column>
        <el-table-column label="备注内容" prop="remark">
          <template slot-scope="scope">
            <el-link type="danger" icon="el-icon-s-flag" v-if="scope.row.type == 4"></el-link>
            <el-link type="primary" icon="el-icon-s-flag" v-if="scope.row.type == 3"></el-link>
            <el-link type="warning" icon="el-icon-s-flag" v-if="scope.row.type == 2"></el-link>
            <el-link type="info" icon="el-icon-s-flag" v-if="scope.row.type == 1"></el-link>
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column label="备注人" prop="adminer"></el-table-column>
        <el-table-column label="备注人岗位" prop="position">
          <template slot-scope="scope">
            {{ scope.row.position == 1 ? '售中' : scope.row.position == 2 ? '售后' : scope.row.position == 3 ? '售前' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="备注时间" prop="created_at"></el-table-column>
      </el-table>

      <span slot="footer">
        <el-button @click="showRemarksStatus = false">关闭</el-button>
        <el-button type="primary" @click="saveRemark">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="photoShow">
      <img width="100%" :src="photoUrl" alt="" />
    </el-dialog>

    <!-- 短信弹窗 -->

    <el-dialog title="短信发送" :visible.sync="smsShow" :close-on-click-modal="false">
      <el-form :model="smsForm" label-width="160px" :inline="false" size="small" style="height: 100%; overflow-y: auto">
        <el-form-item label="短信模板">
          <el-select v-model="smsForm.id" placeholder="选择短信模板" @change="choosedSMS">
            <el-option v-for="option in smsTemplates" :key="option.id" :label="option.title" :value="option.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="短信内容" prop="content">
          <el-input
            type="textarea"
            v-model="smsForm.content"
            :autosize="{ minRows: 8, maxRows: 20 }"
            placeholder="请填写短信内容"
            size="mini"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="smsHistories" border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="短信内容" prop="content"></el-table-column>
        <el-table-column label="发送人" width="100" prop="adminer"></el-table-column>
        <el-table-column label="发送时间" width="200" prop="created_at"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="cancelSMS">取消</el-button>
        <el-button type="primary" @click="subSMS">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="开卡"
      :visible.sync="showOpenCard"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @close="closeShow"
    >
      <el-form :model="cardForm" ref="cardForm" :rules="cardRules" label-width="80px" :inline="false" size="mini">
        <el-form-item label="结算方式">
          <el-radio-group v-model="cardForm.type" @change="change">
            <el-radio :label="1">采购卡</el-radio>
            <el-radio :label="2">月结卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="结算渠道">
          <el-select v-model="cardForm.channel_id" filterable @change="getCards" style="width: 100%">
            <el-option v-for="channel in channels" :key="channel.id" :label="channel.title" :value="channel.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号">
          <el-select v-model="cardForm.card_id" filterable style="width: 100%">
            <el-option
              v-for="card in cards"
              :key="card.id"
              :label="card.code + '[' + card.sex_text + (card.city ? card.city : '') + ']'"
              :value="card.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="openCard">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="上传报告"
      :visible.sync="showImportReportDialog"
      width="40%"
      :before-close="importReportCancel"
      :close-on-click-modal="false"
    >
      <el-form
        :model="importReportData"
        ref="importReportData"
        :rules="rules"
        label-width="160px"
        :inline="false"
        size="small"
        style="height: 100%; overflow-y: auto;"
      >
        <el-form-item label="检测人" prop="tester">
          <el-input v-model="importReportData.tester" style="width: 300px;" placeholder="请输入检测人"></el-input>
        </el-form-item>

        <el-form-item label="上传报告">
          <el-upload
            class="upload-demo"
            :action="uploadReportUrl"
            :headers="uploadHeaders"
            :file-list="file_list"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :on-preview="handlePreview"
            :data="importReportData"
            accept=".pdf,.png,.jpg,.jpeg"
            :on-success="uploadSuccess"
            :on-progress="uploadProgress"
            :disabled="uploadReportLoading"
            name="report_file"
            :show-file-list="true"
            :auto-upload="false"
            :limit="1"
            ref="reportUpload"
          >
            <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>

            <div slot="tip" class="el-upload__tip" style="color:red">
              （注：请上传.pdf,.png,.jpg,.jpeg文件<span v-if="importReportData.report_path"
                >，若要选择文件更换报告，请先删除下面报告文件</span
              >）
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="success" :loading="uploadReportLoading" @click="submitUpload">确定</el-button>
        <el-button @click="importReportCancel()">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="查看更多"
      :visible.sync="showMoreCode"
      :before-close="showMoreCodeClose"
      :close-on-click-modal="false"
      width="50%"
    >
      <div v-loading="moreCodeLoad">
        <div class="batchs">
          <el-date-picker
            style="margin-left: 10px;"
            v-model="datevalue"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            size="mini"
          >
          </el-date-picker>
          <el-popconfirm
            placement="right"
            confirm-button-text="改预处理时间"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            title="确定要批量改时间吗？"
            @confirm="updateDate"
            style="margin-left: 10px;"
          >
            <el-button slot="reference" type="primary" size="mini">批量改预处理时间</el-button>
          </el-popconfirm>
          <el-select
            placeholder="选择发货状态"
            size="mini"
            v-model="shippingStatus"
            style="width: 150px;height: 40px;padding: 0 10px;"
          >
            <el-option v-for="option in shippingStatusList" :key="option.id" :label="option.title" :value="option.id">
            </el-option>
          </el-select>
          <el-popconfirm v-if="shippingStatus !== ''" title="确定批量修改吗？" @confirm="UpdateConfirmBatch">
            <el-button slot="reference" type="primary" size="mini">批量修改状态</el-button>
          </el-popconfirm>
        </div>
        <el-checkbox style="margin-top: 10px;" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div class="verify" v-for="verify in moreVerifyCodes.list" :key="verify.id">
          <div class="verify_child">
            <div class="verify_child_checkbox">
              <el-checkbox-group v-model="checkMoreList" @change="handleCheckedCitiesChange">
                <el-checkbox :label="verify.id">{{ verify.id }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="verify_child_middle">
              <div style="line-height: 25px;">
                <i class="el-icon-user" style="color: #007CFF;"></i>
                &nbsp;收件人：
                {{ moreVerifyCodes.order.consignee }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-mobile-phone" style="color: #007CFF"></i>
                &nbsp;手机号：
                {{ moreVerifyCodes.order.mobile }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-location-outline" style="color: #007CFF"></i>
                &nbsp;收件地址：
                {{ moreVerifyCodes.order.address }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-truck" style="color: #007CFF"></i>
                &nbsp;快递/物流：
                {{ moreVerifyCodes.order.kd_name }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-folder-checked" style="color: #007CFF"></i>
                &nbsp;快递单号：
                {{ verify.kd_no ? verify.kd_no : moreVerifyCodes.order.kd_no }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-time" style="color: #007CFF"></i>
                &nbsp;发货时间：
                {{ moreVerifyCodes.order.kd_adminer_time }}
              </div>
            </div>
            <div class="verify_child_right">
              <div style="line-height: 25px;">
                发货状态：<span style="color: #007CFF;">
                  <tableEditSelect
                    propsName="shipping_status"
                    :options="shippingStatusList"
                    :info="verify"
                    url="order/order_pretreatment/quick"
                  >
                  </tableEditSelect>
                </span>
              </div>
              <div class="flex" style="line-height: 25px;">
                处理星级：<el-rate :value="verify.dispose_star" @change="value => star(value, verify.id, verify)"> </el-rate>
              </div>
              <div class="flex" style="line-height: 25px;">
                预处理时间：<tableEditDate propsName="pretreatment_time" :info="verify" url="order/order_pretreatment/quick">
                </tableEditDate>
              </div>
              <div style="line-height: 25px; margin-top: 5px;" class="flex">
                <el-button size="mini" type="danger" @click="onErr(verify)" v-if="verify.shipping_status == 0">退回 </el-button>
                <el-button
                  v-if="verify.shipping_status == 0 || verify.shipping_status == 1"
                  size="mini"
                  type="warning"
                  @click="save"
                  >保存</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  @click="toRefundDetainment(verify.order_id, verify.order_item_id, verify.id)"
                  >退款挽留
                </el-button>
              </div>
              <div @click="showRemarkspretreatment(verify.id, verify.remark_logs)" style="cursor: pointer; margin-top: 10px;">
                <div v-if="verify.remark_logs.length > 0">
                  备注：
                  <el-link type="danger" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 4"> </el-link>
                  <el-link type="primary" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 3"> </el-link>
                  <el-link type="warning" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 2"> </el-link>
                  <el-link type="info" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 1"> </el-link>
                </div>
                <div v-else>备注：<el-link type="info" icon="el-icon-s-flag"></el-link></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showMoreCodeClose">取 消</el-button>
        <el-button type="primary" @click="save">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="退款挽留"
      :visible.sync="refundDetainmentInfoShow"
      :close-on-click-modal="false"
      width="60%"
      @close="resetRefundDetainmentInfo"
    >
      <div style="margin-bottom: 10px;" v-if="refundDetainmentInfoData.length <= 0">
        <el-button @click="uploadRefundDetainment">新增</el-button>
      </div>
      <el-table :data="refundDetainmentInfoData" border stripe>
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column label="申请人" prop="staff_name">
          <template slot-scope="scope">
            {{ scope.row.staff_name ? scope.row.staff_name : '' }}
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="created_at">
          <template slot-scope="scope">
            {{ scope.row.created_at ? scope.row.created_at : '' }}
          </template>
        </el-table-column>
        <el-table-column label="申请凭证" prop="voucher">
          <template slot-scope="scope">
            <div v-if="scope.row.voucher && scope.row.voucher != [] && scope.row.voucher.length > 0">
              <el-link type="primary" @click="showVoucher(item)" v-for="(item, i) in scope.row.voucher" :key="i">
                【凭证{{ i + 1 }}】
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editRefundDetainment(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="resetRefundDetainmentInfo">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="上传凭证图片"
      :visible.sync="uploadRefundDetainmentInfoShow"
      width="40%"
      @close="resetUploadRefundDetainmentInfo"
      :close-on-click-modal="false"
    >
      <el-upload
        ref="upload"
        :file-list="fileList"
        :auto-upload="false"
        :on-change="handleChangeVoucher"
        :on-remove="handleRemoveVoucher"
        action="#"
        multiple
        list-type="picture-card"
      >
        <i class="el-icon-plus avatar-uploader-icon" style="color:#007CFF"></i>
      </el-upload>
      <span slot="footer">
        <el-button @click="resetUploadRefundDetainmentInfo">取消</el-button>
        <el-button type="primary" @click="subimgInfo">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableEditDate from '@/components/TableEditDate'
import tableEditSelect from '@/components/TableEditSelect'

export default {
  name: 'AfterSaleReal',
  components: {
    tableEditDate,
    tableEditSelect,
  },
  data() {
    return {
      value: '',
      title: '预约日期',
      loading: true,
      showOpenCard: false,
      channels: [],
      cards: [],
      provinces: [],
      cities: [],
      filter: {
        province: '',
        city_code: '',
        district: '',
        keyword: '',
        star_sort: '',
        create_sort: '',
        time_type: 'created_at',
        status: [],
        store_id: '',
        order_type: '',
        is_pretreatment: 1,
        is_processed: '',
      },
      cardForm: {
        type: 1,
        channel_id: '',
        card_id: '',
      },
      cardRules: {
        card_id: [
          {
            required: true,
            message: '请选择体检卡',
            trigger: 'change',
          },
        ],
      },
      checkList: [],
      radioVal: '7',
      tableData: [],
      tableDataSummary: [],
      statusList: [
        {
          id: 1,
          title: '已发货',
          type: 'warning',
        },
        {
          id: 2,
          title: '已完成',
          type: 'success',
        },
        {
          id: 3,
          title: '已取消',
          type: 'info',
        },
      ],
      shippingStatusList: [
        {
          id: 1,
          title: '已发货',
          type: 'warning',
        },
        {
          id: 2,
          title: '已完成',
          type: 'success',
        },
        {
          id: 3,
          title: '已取消',
          type: 'info',
        },
      ],
      page: 1,
      maxpage: 1,
      total: 0,
      infoShow: false,
      saveType: 1, // 1新增 2编辑
      info: {
        realname: '',
        mobile: '',
        sex: 1,
        merry: 1,
        id_type: 1,
        id_no: '',
        org_id: '',
        inoculate_org_id: '',
      },
      rules: {
        title: [
          {
            required: true,
            message: '请填写体检卡名称',
            trigger: 'blur',
          },
        ],
      },
      stores: [],
      shops: [],
      shops2: [],
      showRemarksStatus: false,
      remarks: [],
      remarkForm: {
        type: 1,
        remark: '',
        position: 1,
      },
      remarkRules: {
        remark: [
          {
            required: true,
            message: '请填写备注内容',
            trigger: 'blur',
          },
        ],
      },
      totalData: {},
      uploadLoading: false,
      uploadHeaders: {
        Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
      uploadUrl: this.$util.host + '/api/upload?type=reports',
      uploadReportUrl: this.$util.host + '/api/order/order_items/upload_new_report',
      photoShow: false,
      photoUrl: '',
      vaccinesPaymentData: {
        amount: 0,
        appointment_id: 0,
        fee_type: '',
        fee_time: '',
        fee_status: 1,
        vaccine_time: '',
        remark: '',
      },
      vaccinesPaymentClose: false,
      vaccinesPaymentPowerEdit: false,
      showVaccineDialog: false,
      showVaccineStatusDialog: false,
      vaccinesStatusData: {
        vaccine_time: '',
        remark: '',
      },
      citys: [],
      summaryType: 0,
      smsShow: false,
      smsForm: {
        id: '',
        content: '',
      },
      smsTemplates: [],
      smsHistories: [],
      smsTempForm: null,
      saveLoading: false,
      showImportReportDialog: false,
      importReportData: {
        item_id: 0,
        tester: '',
        report_path: '',
        the_num: 0,
        order_pretreatment_id: '',
      },
      uploadReportLoading: false,
      file_list: [],
      statusLists: [],
      showMoreCode: false,
      moreVerifyCodes: [],
      moreCodeLoad: false,
      checkAll: false,
      isIndeterminate: false,
      checkMoreList: [],
      uploadStatus: '',
      datevalue: '',
      orderInfo: {
        order_id: '',
        order_item_id: '',
      },
      pretreatmentremarks: [],
      showRemarkspretreatmentStatus: false,
      pretreatmentremarkForm: {
        type: 1,
        remark: '',
        position: 1,
      },
      refundDetainmentInfoShow: false,
      refundDetainmentInfo: {
        order_id: '',
        order_item_id: '',
        order_pretreatment_id: '',
        voucher: [],
      },
      uploadRefundDetainmentInfoShow: false,
      fileList: [],
      fileList1: [],
      refundDetainmentInfoData: [],
      shippingStatus: '',
    }
  },
  mounted() {
    let query = this.$route.query
    if (query.keyword) {
      this.filter.keyword = query.keyword
      if (query.card_id) {
        this.filter.card_id = query.card_id
      }
      this.page = 1
      this.filter.status = []
      this.filter.deal_status = []
      this.filter.vaccine_status = []
      this.filter.needle_type = 0
      this.filter.city_code = ''
    }
    this.getTableData()
    // this.getShops();
    // this.getStores();
    // this.getProvinces();
  },
  watch: {
    $route(to) {
      if (to.query.keyword && to.name == 'appointments') {
        this.filter.keyword = to.query.keyword
        if (to.query.card_id) {
          this.filter.card_id = to.query.card_id
        }
        this.page = 1
        this.filter.status = []
        this.filter.deal_status = []
        this.filter.vaccine_status = []
        this.filter.needle_type = 0
        this.filter.city_code = ''
        this.getTableData()
      }
    },
  },
  filters: {
    toDate(date) {
      return date ? date.substring(0, 10) : ''
    },
  },
  methods: {
    closeShow() {
      this.cardForm = {
        type: 1,
        channel_id: '',
        card_id: '',
      }
      this.cards = ''
    },
    getTableData(val) {
      if (val == 1) {
        this.title = '接种时间'
      } else if (val == 2) {
        this.title = '体检时间'
      } else {
        this.title = '预约时间'
      }
      this.tableData = []
      let data = this.filter
      data.page = this.page
      data.page_row = 10
      this.loading = true
      this.filter.audit_status = 1
      this.$util.get('/merchant/order/appoint/real', data).then(res => {
        res.data.forEach(item => {
          let rowdata = item
          item.showAddVaccinesPayment = true
          if (item.vaccines && item.vaccines.length > 0) {
            let tempVaccines = item.vaccines
            for (let i = 0; i < tempVaccines.length; i++) {
              if (tempVaccines[i].fee_type == 6) {
                item.showAddVaccinesPayment = false
              }
            }
          } else {
            rowdata.vaccineStatusProcess = {
              id: 0,
              type: 0,
              type_text: '',
              data: [],
            }
          }
          if (!item.order_items[0].order_pretreatments[0]) {
            this.statusLists = []
          } else if (item.order_items[0].order_pretreatments[0].shipping_status == 0) {
            this.statusLists = ['待发货']
          } else if (item.order_items[0].order_pretreatments[0].shipping_status == 1) {
            this.statusLists = ['待发货', '已发货']
          } else if (item.order_items[0].order_pretreatments[0].shipping_status == 2) {
            this.statusLists = ['待发货', '已发货', '已完成']
          } else if (item.order_items[0].order_pretreatments[0].shipping_status == 3) {
            this.statusLists = ['已取消']
          } else if (item.order_items[0].order_pretreatments[0].shipping_status == 4) {
            this.statusLists = ['待发货', '已发货', '退款中']
          } else {
            this.statusLists = ['已退款']
          }
          rowdata.statusLists = this.statusLists
          this.tableData.push(rowdata)
        })
        this.loading = false
        this.maxpage = res.last_page
        this.total = res.total
        this.totalData = res.total_data
        this.vaccinesPaymentClose = res.hasAppointmentVaccinesDeletePower == 1 ? true : false
        this.vaccinesPaymentPowerEdit = res.hasAppointmentVaccinesPower == 1 ? true : false
      })
    },
    star(value, verify_id, scope) {
      this.break()
      this.$confirm('是否确认修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$util.put('order/order_pretreatment/quick/' + verify_id, {
            field: 'dispose_star',
            value: value,
          })
          this.$message({
            type: 'success',
            message: '修改成功!',
          })
          scope.dispose_star = value
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改',
          })
        })
    },
    openCardShow(vid, gid) {
      this.showOpenCard = true
      this.cardForm.verify_id = vid
      this.cardForm.good_id = gid
      this.getChannels()
    },
    cancel() {
      this.showOpenCard = false
      this.cardForm = {
        type: 1,
        channel_id: '',
        card_id: '',
      }
    },
    getProvinces(level = 1) {
      this.break()
      this.$util
        .get('slc', {
          model: 'Area',
          level: level,
          parent_id: 0,
        })
        .then(res => {
          this.provinces = res
        })
    },
    getCities(level = 2) {
      this.break()
      this.$util
        .get('slc', {
          model: 'Area',
          level: level,
          parent_id: this.filter.province,
        })
        .then(res => {
          this.cities = res
        })
    },
    getShops(appointment_id) {
      this.break()
      this.$util
        .get('slc', {
          model: 'Shop',
          appointment_id: appointment_id,
        })
        .then(res => {
          this.shops = res
        })
    },
    getShops2() {
      this.break()
      this.$util.get('/shops/inoculate_org').then(res => {
        this.shops2 = res
      })
    },
    getStores() {
      this.break()
      this.$util
        .get('slc', {
          model: 'Store',
        })
        .then(res => {
          this.stores = res
        })
    },
    getCitys() {
      this.break()
      this.$util
        .get('slc', {
          model: 'Area',
          level: 2,
        })
        .then(res => {
          this.citys = res
        })
    },
    getCards() {
      this.break()
      this.$util
        .get('slc', {
          model: 'Card',
          good_id: this.cardForm.good_id,
          channel_id: this.cardForm.channel_id,
          type: this.cardForm.type,
        })
        .then(res => {
          this.cards = res
        })
    },
    getChannels() {
      this.break()
      this.$util
        .get('slc', {
          model: 'Channel',
        })
        .then(res => {
          this.channels = res
        })
    },
    openCard() {
      this.break()
      this.$refs['cardForm'].validate(valid => {
        if (valid) {
          this.$util
            .put('order/order_pretreatment/quick/' + this.cardForm.verify_id, {
              field: 'card_id',
              value: this.cardForm.card_id,
            })
            .then(res => {
              if (res.code != 0) {
                this.$message(res.msg ? res.msg : '操作失败')
              } else {
                this.showOpenCard = false
                this.getTableData()
              }
            })
        } else {
          return false
        }
      })
    },
    onRecovery(vid, cid) {
      this.break()
      this.$util
        .put('order/order_pretreatment/recycle_card', {
          card_id: cid,
          order_pretreatment_id: vid,
          is_recycle: 1,
        })
        .then(res => {
          if (res.code == 0) {
            this.showRefundStatus = false
            this.getTableData()
          } else {
            this.$message(res.msg ? res.msg : '操作失败')
          }
        })
    },
    getSMS(id) {
      this.break()
      this.$util
        .get('slc', {
          model: 'SmsTemplate',
        })
        .then(res => {
          this.smsTemplates = res
        })
      this.$util
        .get('crm/notices', {
          appointment_id: id,
        })
        .then(res => {
          this.smsHistories = res.data
        })
    },
    onSearch() {
      this.tableData = []
      this.page = 1
      this.maxpage = 1
      this.total = 0
      this.filter.card_id = ''
      this.getTableData()
    },
    onRefresh() {
      this.radioVal = 7
      this.checkList = []
      this.filter.status = []
      this.getTableData()
    },
    checkChange(val) {
      this.radioVal = ''
      val.forEach(item => {
        if (item < 0) {
          this.filter.is_pretreatment = ''
          this.filter.is_processed = ''
          this.filter.status = []
        } else if (item >= 0 && item != 10) {
          this.filter.status = val
          this.filter.is_pretreatment = ''
          this.filter.is_processed = ''
        }
      })
    },
    radioChange(val) {
      if (this.checkList.length > 0) {
        if (val == 7) {
          this.filter.is_pretreatment = 1
          this.filter.is_processed = ''
        } else if (val == 8) {
          this.filter.is_processed = 1
          this.filter.is_pretreatment = ''
        }
      } else {
        if (val == 7) {
          this.filter.status = []
          this.filter.is_pretreatment = 1
          this.filter.is_processed = ''
        } else if (val == 8) {
          this.filter.status = []
          this.filter.is_processed = 1
          this.filter.is_pretreatment = ''
        }
      }
    },
    pageChange(page) {
      this.tableData = []
      this.page = page
      this.getTableData()
    },
    onCreate() {
      this.getShops2()
      this.saveType = 1
      this.infoShow = true
    },
    onEdit(row) {
      this.saveType = 2
      this.info = {
        id: row.id,
        realname: row.realname,
        mobile: row.mobile,
        sex: row.sex,
        merry: row.merry,
        id_type: row.id_type,
        id_no: row.id_no,
        visit_time: row.visit_time,
        org_id: row.org_id,
        shop_id: row.shop_id,
        dispose_star: row.dispose_star,
        inoculate_org_id: row.inoculate_org_id,
      }
      this.getShops(row.id)
      this.getShops2()
      this.infoShow = true
    },
    break() {
      let bool = true
      if (bool) return
    },
    onErr(row) {
      this.break()
      this.$confirm('退回订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$util
            .put('order/order_pretreatment/quick/' + row.id, {
              field: 'audit_status',
              value: 0,
            })
            .then(() => {
              this.getTableData()
              this.showMoreCode = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核',
          })
        })
    },
    onQuick(id, field, val) {
      this.break()
      this.$util
        .put('order/appointment/quick/' + id, {
          field: field,
          value: val,
        })
        .then(() => {
          this.getTableData()
        })
    },
    subInfo() {
      this.break()
      this.$refs['info'].validate(valid => {
        if (valid) {
          if (this.saveType == 1) {
            this.info.visit_time = this.$moment(this.info.visit_time).format('YYYY-MM-DD')
            this.$util.post('order/appointment', this.info).then(() => {
              this.getTableData()
              this.infoShow = false
            })
          } else {
            this.info.visit_time = this.$moment(this.info.visit_time).format('YYYY-MM-DD')
            this.$util.put('order/appointment/' + this.info.id, this.info).then(res => {
              if (res.code == 0) {
                this.getTableData()
                this.infoShow = false
              } else {
                this.$message(res.msg ? res.msg : '操作失败')
              }
            })
          }
        } else {
          return false
        }
      })
    },
    resetInfo() {
      this.info = {
        realname: '',
        mobile: '',
        sex: 1,
        merry: 1,
        id_type: 1,
        id_no: '',
        visit_time: '',
        org_id: '',
      }
    },
    onSMS(row) {
      this.getSMS(row.id)
      this.smsShow = true
      this.smsTempForm = {
        id: row.id,
        mobile: row.mobile,
        realname: row.realname,
        sex: row.sex == 1 ? '男' : '女',
        merry: row.merry == 1 ? '已婚' : '未婚',
        visit_time: row.visit_time,
        good_title: row.verify_codes[0].order_item.title,
        shop_title: row.store.note_title,
        address: row.org.address,
        order_no: row.verify_codes[0].order_no,
      }
    },
    choosedSMS(val) {
      let content = ''
      this.smsTemplates.forEach(smsTemplate => {
        if (smsTemplate.id == val) {
          content = smsTemplate.content
        }
      })
      if (content.indexOf('{order_no}') >= 0) {
        content = content.replace('{order_no}', this.smsTempForm.order_no)
      }
      if (content.indexOf('{realname}') >= 0) {
        content = content.replace('{realname}', this.smsTempForm.realname)
      }
      if (content.indexOf('{sex}') >= 0) {
        content = content.replace('{sex}', this.smsTempForm.sex)
      }
      if (content.indexOf('{merry}') >= 0) {
        content = content.replace('{merry}', this.smsTempForm.merry)
      }
      if (content.indexOf('{good_title}') >= 0) {
        content = content.replace('{good_title}', this.smsTempForm.good_title)
      }
      if (content.indexOf('{visit_time}') >= 0) {
        content = content.replace('{visit_time}', this.smsTempForm.visit_time)
      }
      if (content.indexOf('{shop_address}') >= 0) {
        content = content.replace('{shop_address}', this.smsTempForm.address)
      }
      content = `【${this.smsTempForm.shop_title}】` + content
      this.smsForm.content = content
    },
    cancelSMS() {
      this.smsShow = false
      this.smsForm = {
        id: '',
        content: '',
      }
      this.smsTempForm = null
    },
    subSMS() {
      this.break()
      let data = {
        appointment_id: this.smsTempForm.id,
        content: this.smsForm.content,
        realname: this.smsTempForm.realname,
        mobile: this.smsTempForm.mobile,
      }
      this.$util.post('crm/notices', data).then(() => {
        this.smsShow = false
      })
    },
    showOrder(order_no) {
      this.break()
      this.$store.commit('delete_tabs', 'order_all')
      this.$router.replace({
        path: '/order/order_all',
        query: {
          keyword: order_no,
        },
      })
    },
    showRemarks(id, remarks) {
      this.showRemarksStatus = true
      this.remarks = remarks
      this.remarkForm.order_pretreatment_id = id
    },
    resetRemark() {
      this.remarkForm = {
        type: 1,
        remark: '',
        position: 2,
      }
    },
    pretreatmentresetRemark() {
      this.pretreatmentremarkForm = {
        type: 1,
        remark: '',
        position: 1,
      }
    },
    saveRemark() {
      this.break()
      this.$refs['remarkForm'].validate(valid => {
        if (valid) {
          this.$util.post('order/orderPretreatmentRemarkLogs', this.remarkForm).then(() => {
            this.getTableData()
            this.showRemarksStatus = false
          })
        } else {
          return false
        }
      })
    },
    uploadSuccess(response, file, fileList) {
      this.$refs.reportUpload.clearFiles()

      console.log('success', response, file, fileList)
      if (response.code != 0) {
        this.$message.error(response.msg ? response.msg : '保存失败')
        this.uploadReportLoading = false
      } else {
        this.$message('保存成功')
        this.importReportCancel()
        this.getTableData()
      }
    },
    showPreview(url) {
      var arr = url.split('.')
      var fileExtension = arr[arr.length - 1].toLowerCase()
      if (fileExtension == 'pdf') {
        window.open(url, '_blank')
      } else {
        this.photoUrl = url
        this.photoShow = true
      }
    },
    do_export() {
      this.break()
      let data = this.filter
      let url = this.$util.host + '/api/appointment/export'
      let param = ''
      for (let i in data) {
        param += '&' + i + '=' + data[i]
      }
      param = param.trimLeft('&')
      url += '?' + param
      this.$confirm('若导出失败，请先选择查询条件后再导出').then(() => {
        window.open(url)
      })
    },
    addvaccinesPayment(appId, vaccinie = null) {
      this.showVaccineDialog = true
      if (vaccinie) {
        this.vaccinesPaymentData = {
          ...vaccinie,
        }
      }
      this.vaccinesPaymentData.appointment_id = appId
    },
    cancelVaccineSave() {
      this.showVaccineDialog = false
      this.vaccinesPaymentData = {
        amount: 0,
        appointment_id: 0,
        fee_type: '',
        fee_time: '',
        fee_status: 1,
        vaccine_time: '',
        remark: '',
      }
    },
    doVaccineSave() {
      this.break()
      if (!this.vaccinesPaymentData.fee_type) {
        this.$message.error('请选择付费进度')
        return false
      }
      if (this.vaccinesPaymentData.fee_time) {
        this.vaccinesPaymentData.fee_time = this.$moment(this.vaccinesPaymentData.fee_time).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.vaccinesPaymentData.vaccine_time) {
        this.vaccinesPaymentData.vaccine_time = this.$moment(this.vaccinesPaymentData.vaccine_time).format('YYYY-MM-DD HH:mm:ss')
      }
      this.saveLoading = true
      if (this.vaccinesPaymentData.id > 0) {
        this.$util.put('order/appointment_vaccine/' + this.vaccinesPaymentData.id, this.vaccinesPaymentData).then(res => {
          this.saveLoading = false
          if (res.code != 0) {
            this.$message(res.msg ? res.msg : '操作失败')
          } else {
            this.getTableData()
            this.cancelVaccineSave()
          }
        })
      } else {
        this.$util.post('order/appointment_vaccine', this.vaccinesPaymentData).then(res => {
          this.saveLoading = false
          if (res.code != 0) {
            this.$message(res.msg ? res.msg : '操作失败')
          } else {
            this.getTableData()
            this.cancelVaccineSave()
          }
        })
      }
    },
    paymenthandleClose(item) {
      this.break()
      this.$confirm('确定删除吗？')
        .then(() => {
          this.$util
            .put('order/appointment_vaccine/quick/' + item.id, {
              field: 'is_delete',
              value: 1,
            })
            .then(res => {
              if (res.code != 0) {
                this.$message(res.msg ? res.msg : '操作失败')
              } else {
                this.getTableData()
              }
            })
        })
        .catch(() => {})
    },
    handleVacciniesStatus(val, id, feeType) {
      this.break()
      this.$confirm('确定修改' + feeType + '状态吗？')
        .then(() => {
          this.$util
            .put('order/vaccine_update_status/' + id, {
              status: val,
            })
            .then(res => {
              if (res.code != 0) {
                this.$message(res.msg ? res.msg : '操作失败')
              } else {
                this.getTableData()
              }
            })
        })
        .catch(() => {})
    },
    showVaccineStatusDialogFun(item) {
      this.vaccinesStatusData.vaccine_time = item.vaccine_time
      this.vaccinesStatusData.id = item.id
      this.vaccinesStatusData.remark = item.remark
      this.showVaccineStatusDialog = true
    },
    cancelVaccineStatusDialogFun() {
      this.vaccinesStatusData = {
        vaccine_time: '',
        remark: '',
      }
      this.showVaccineStatusDialog = false
    },
    doVaccineStatusSave() {
      this.break()
      if (this.vaccinesStatusData.id <= 0) {
        this.$message('操作参数id获取失败')
        return false
      }
      this.$util.put('order/vaccine_update_status/' + this.vaccinesStatusData.id, this.vaccinesStatusData).then(res => {
        if (res.code != 0) {
          this.$message(res.msg ? res.msg : '操作失败')
        } else {
          this.cancelVaccineStatusDialogFun()
          this.getTableData()
        }
      })
    },
    changeSummaryType() {
      this.getTableData()
    },
    change(event) {
      this.cardForm.type = event
      this.cardForm.channel_id = ''
      this.cardForm.card_id = ''
    },
    save() {
      this.getTableData()
      this.showMoreCode = false
    },
    uploadProgress(file) {
      console.log('progress', file)
      this.uploadReportLoading = true
    },
    handleChange(file, fileList) {
      console.log(file, fileList)
      this.file_list = fileList
    },
    handleRemove(file, fileList) {
      this.file_list = fileList
      console.log(file, fileList)
    },
    handlePreview(file) {
      if (file && file.url) {
        this.showPreview(file.url)
      }
    },
    importReportShow(item_id, row) {
      if (row.reports && row.reports.length > 0) {
        this.importReportData = {
          item_id: item_id,
          tester: row.reports[0].report_tester,
          report_path: row.reports[0].report_path,
          order_pretreatment_id: row.id,
        }
      } else {
        this.importReportData = {
          item_id: item_id,
          tester: '',
          report_path: '',
          order_pretreatment_id: row.id,
        }
      }
      if (row.reports && row.reports.length > 0 && row.reports[0].report_path) {
        this.file_list.push({
          name: '报告文件',
          url: row.reports[0].report_path,
        })
      }
      this.showImportReportDialog = true
    },
    importReportCancel() {
      this.importReportData = {
        item_id: 0,
        tester: '',
        report_path: '',
        order_pretreatment_id: '',
      }
      this.file_list = []
      this.showImportReportDialog = false
      this.uploadReportLoading = false
    },
    submitUpload() {
      this.break()
      if (!this.importReportData.tester) {
        this.$message.error('请先输入检测人')
        return false
      }
      if (this.file_list.length <= 0) {
        this.$message.error('请先选择上传文件')
      } else {
        if (this.file_list[0].raw) {
          this.$refs.reportUpload.submit()
        } else {
          this.$util.post('order/order_items/upload_new_report', this.importReportData).then(res => {
            this.uploadSuccess(res, [], this.file_list)
            this.showImportReportDialog = false
          })
        }
      }
    },
    delReport(item_id, order_pretreatment_id) {
      this.break()
      this.$confirm('确定删除吗？')
        .then(() => {
          this.$util
            .post('order/order_items/del_report', {
              item_id: item_id,
              order_pretreatment_id: order_pretreatment_id,
            })
            .then(res => {
              if (res.code != 0) {
                this.$message(res.msg ? res.msg : '操作失败')
              } else {
                this.getTableData()
              }
            })
        })
        .catch(() => {})
    },
    setOrderInfo(order_id, order_item_id) {
      this.orderInfo.order_id = order_id
      this.orderInfo.order_item_id = order_item_id
    },
    getMoreCode(order_id, item_id) {
      this.break()
      this.setOrderInfo(order_id, item_id)
      this.showMoreCode = true
      this.batchOpenCardOrderId = order_id
      this.moreVerifyCodes = []
      this.moreCodeLoad = true
      this.checkMoreList = []
      this.checkAll = false
      this.isIndeterminate = false
      this.$util
        .get('order/order_pretreatment/get_more_shipping', {
          order_id: order_id,
          order_item_id: item_id,
          audit_status: 1,
        })
        .then(res => {
          this.moreCodeLoad = false
          this.moreVerifyCodes = res
        })
    },
    showMoreCodeClose() {
      this.showMoreCode = false
      this.moreVerifyCodes = []
      this.shippingStatus = ''
      this.moreCodeLoad = false
    },
    updateDate() {
      this.break()
      this.$util
        .put('order/order_pretreatment/batch_time', {
          ids: this.checkMoreList,
          time: this.datevalue,
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(res.data)
            this.datevalue = ''
            this.getMoreCode(this.orderInfo.order_id, this.orderInfo.order_item_id)
          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    UpdateConfirmBatch() {
      this.break()
      this.$util
        .put('order/order_pretreatment/shipping_status', {
          shipping_status: this.shippingStatus,
          id_str: this.checkMoreList.join(','),
          order_id: this.orderInfo.order_id,
          order_item_id: this.orderInfo.order_item_id,
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(res.data)
            this.shippingStatus = ''
            this.getMoreCode(this.orderInfo.order_id, this.orderInfo.order_item_id)
          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    handleCheckAllChange(val) {
      const all = this.moreVerifyCodes.list.map(verify => {
        return verify.id
      })
      this.checkMoreList = val ? all : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.moreVerifyCodes.list.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.moreVerifyCodes.list.length
    },
    showRemarkspretreatment(id, remarks) {
      this.showRemarkspretreatmentStatus = true
      this.pretreatmentremarks = remarks
      this.pretreatmentremarkForm.order_pretreatment_id = id
    },
    saveRemarkpretreatment() {
      this.break()
      this.$refs['pretreatmentremarkForm'].validate(valid => {
        if (valid) {
          this.$util.post('order/orderPretreatmentRemarkLogs', this.pretreatmentremarkForm).then(() => {
            this.getTableData()
            this.showRemarkspretreatmentStatus = false
          })
        } else {
          return false
        }
      })
    },
    resetRefundDetainmentInfo() {
      this.refundDetainmentInfo = {
        order_id: '',
        order_item_id: '',
        order_pretreatment_id: '',
        voucher: [],
      }
      this.refundDetainmentInfoData = []
      this.refundDetainmentInfoShow = false
    },
    resetUploadRefundDetainmentInfo() {
      this.fileList = []
      this.fileList1 = []
      this.uploadRefundDetainmentInfoShow = false
    },
    toRefundDetainment(id, oid, pid) {
      this.break()
      this.$util
        .get('finances/order/refundDetainment/getOneList', {
          order_id: id,
          order_item_id: oid,
          order_pretreatment_id: pid,
        })
        .then(res => {
          this.refundDetainmentInfo = {
            order_id: id,
            order_item_id: oid,
            order_pretreatment_id: pid,
          }
          if (res) {
            if (this.refundDetainmentInfoData.length == 0) {
              this.refundDetainmentInfoData.push(res)
            } else {
              this.refundDetainmentInfoData[0] = res
            }
          } else {
            this.refundDetainmentInfoData = []
          }
        })
      this.refundDetainmentInfoShow = true
    },
    uploadRefundDetainment() {
      this.saveType = 1
      this.uploadRefundDetainmentInfoShow = true
    },
    handleChangeVoucher(file) {
      this.break()
      let fetchForm = new FormData()
      fetchForm.append('file', file.raw)
      this.$util.post('upload/', fetchForm).then(res => {
        this.fileList1.push({
          url: res.data,
        })
      })
    },
    handleRemoveVoucher(file, fileList) {
      this.fileList1 = []
      fileList.forEach(item => {
        this.fileList1.push({
          url: item.url,
        })
      })
    },
    editRefundDetainment(row) {
      this.saveType = 2
      this.refundDetainmentInfo = {
        id: row.id,
        order_id: row.order_id,
        order_item_id: row.order_item_id,
        order_pretreatment_id: row.order_pretreatment_id,
        voucher: row.voucher,
      }
      row.voucher.forEach(url => {
        this.fileList.push({
          url: url,
        })
        this.fileList1.push({
          url: url,
        })
      })
      this.uploadRefundDetainmentInfoShow = true
    },
    subimgInfo() {
      this.break()
      this.refundDetainmentInfo.voucher = []
      this.fileList1.forEach(file => {
        this.refundDetainmentInfo.voucher.push(file.url)
      })
      if (this.saveType == 1) {
        this.$util.post('finances/order/refundDetainment', this.refundDetainmentInfo).then(res => {
          if (res.code == 0) {
            this.fileList1 = []
            this.fileList = []
            this.toRefundDetainment(
              this.refundDetainmentInfo.order_id,
              this.refundDetainmentInfo.order_item_id,
              this.refundDetainmentInfo.order_pretreatment_id
            )
            this.uploadRefundDetainmentInfoShow = false
          } else {
            this.$message(res.msg)
          }
        })
      } else {
        this.$util
          .put('finances/order/refundDetainment/quick/' + this.refundDetainmentInfo.id, {
            field: 'voucher',
            value: this.refundDetainmentInfo.voucher,
          })
          .then(res => {
            if (res.code == 0) {
              this.fileList1 = []
              this.fileList = []
              this.toRefundDetainment(
                this.refundDetainmentInfo.order_id,
                this.refundDetainmentInfo.order_item_id,
                this.refundDetainmentInfo.order_pretreatment_id
              )
              this.uploadRefundDetainmentInfoShow = false
            } else {
              this.$message(res.msg)
            }
          })
      }
    },
    showVoucher(url) {
      this.photoUrl = url
      this.photoShow = true
    },
  },
}
</script>

<style scoped>
.order_table {
  width: 98%;
}

.order {
  color: #333;
  font-size: 12px;
  margin-bottom: 20px;
  border: #dcdfe6 1px solid;
}

.order-header {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.order-no span {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  margin-right: 20px;
}

.order-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.membermsg {
  padding-left: 10px;
  font-size: 12px;
  line-height: 20px;
  font-family: PingFang SC;
  color: #363636;
}

.order-items {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.order-item:last-child {
  border-bottom: none;
}

.good {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}

.good-box {
  flex-wrap: wrap;
  width: 40%;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #dcdfe6;
}

.good-box:last-child {
  border-bottom: none;
}

.good-img {
  width: 120px;
  padding: 10px;
  height: 120px;
  margin: 0px;
}

.good-info {
  padding: 10px;
  padding-top: 0px;
  width: 250px;
}

.good-verifies {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-left: 1px solid #dcdfe6;
  /* width: 90%; */
  width: 81%;
  border-top: 1px solid #dcdfe6;
}

.verify {
  display: flex;
  /* width: 90%; */
  /* border-bottom: 1px solid #DCDFE6; */
}

.verify-body {
  vertical-align: top;
  display: inline-block;
  line-height: 25px;
  font-size: 12px;
  width: 50%;
  padding: 10px;
  height: 320px;
}

.verify-body div {
  margin-top: 6px;
}

.verify_child {
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dcdfe6;
}

.verify_child > div {
  display: inline-block;
  vertical-align: top;
}

.verify_child_checkbox {
  width: 15%;
}

.verify_child_middle {
  width: 55%;
}

.verify_child_right {
  width: 30%;
}

.good-title {
  font-size: 12px;
  color: #363636;
}

.good-verifies .verify:last-child {
  border-bottom: none;
}

.verify span {
  margin-right: 10px;
}

.order-payment {
  margin-top: 20px;
}

.payment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-family: PingFang SC;
  color: #363636;
  margin-top: 5px;
}

.editbtn {
  float: right;
  overflow: hidden;
  margin-right: 10px;
  cursor: pointer;
  margin-top: 10px;
}

.wrap1 {
  border-bottom: 1px solid #dcdfe6;
}

.wrap2 {
  border: 1px solid #dcdfe6;
  border-top: none;
  width: 50%;
}

.row-edit-input {
  margin-bottom: 10px;
}

.el-button + .btn-pop {
  margin-left: 10px;
}

.flex {
  display: flex;
  align-items: center;
}

.btn-upload {
  display: inline-block;
  margin: 0 10px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.el-tag--dark {
  border: none;
}

.button-new-tag {
  margin: 20px auto 0px;
  background: #ecf5ff;
  border-radius: 4px;
  width: 125px;
}

.button {
  color: #fff;
  background: #007cff;
  border-radius: 4px;
  line-height: 25px;
  height: 25px;
  width: 85px;
  cursor: pointer;
  margin-left: 5px;
}

.span_days_title {
  color: rgb(153 156 160);
}

.star {
  font-size: 16px;
  font-weight: bold;
}

::v-deep .el-rate__item {
  width: 17px;
}

.el-tag /deep/ .el-icon-close {
  font-size: 16px;
}

.flexd {
  display: flex;
  align-items: center;
}

.flexed {
  display: flex;
  flex-direction: column;
}

.flexed .el-tag {
  width: 125px;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  margin: 0 auto;
  color: #fff;
  background: #007cff;
  border-radius: 4px;
  cursor: pointer;
}

.btngroup {
  float: right;
  display: flex;
}

.btn-bottom {
  float: right;
  width: 60px;
  margin: -40px 0 0 110px;
}

.operation {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  vertical-align: middle;
  width: 19%;
  /* margin-right: 50px; */
  padding: 10px;
}

.speeds {
  width: 60px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  margin: 0 auto;
  color: #fff;
  border-radius: 4px;
  text-align: center;
}

.moreCode {
  color: #999da0;
  text-align: center;
  padding: 5px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
